import { styled, Switch } from '@mui/material';

export const VySwitch = styled(Switch)(() => ({
  '& .MuiSwitch-switchBase.Mui-checked': {
    color: '#191e39',
    '& .MuiSwitch-track': {
      backgroundColor: '#C4C7CB !important',
    },
  },
  '& .MuiSwitch-track': {
    backgroundColor: '#C4C7CB !important',
  },
}));